module.exports = __webpack_public_path__ + "img/140-east-timor.78d60a92.svg";